import TotalHours from '@/components/TotalHours.vue';
<template>
  <div>
      <div
    class="uk-card uk-card-default uk-card-body uk-border-rounded uk-background-gradient-primary uk-light uk-margin totalHours"
  >
    Horas Totales:
    <h2 class="uk-margin-remove">{{ TotalHours }} hrs</h2>
    <span class="uk-text-small">Nota: 0.5 equivale a 30 minutos</span>
  </div>
  </div>
</template>
<script>
export default {
  name: "TotalHours",
  props: {
      TotalHours:{
            type: Number,
            required: true
      }
  },
};
</script>
